const labels = {
  accommodationDetailsMoreDetails: 'More Details',
  accommodationOptionsHeader: 'Accommodation Options',
  availableDates: 'Available Dates',
  bookingPrompt: 'To book this vacation, Call: ',
  bookingNextStep: 'Next Step',
  bookingRequestQuote: 'Request A Quote',
  close: 'Close',
  countries: 'Countries',
  country: 'Country',
  day: 'Day',
  days: 'Days',
  featureAdditionalAmentities: 'Value Add',
  featureAddress: 'Location',
  featureAmenities: 'Amenities',
  featureAirport: 'Airport',
  featureDining: 'Dining',
  featureGeneral: 'General',
  featureParking: 'Parking',
  galleryFeatured: 'Featured',
  galleryImageSource: 'All images sourced from Leonardo',
  galleryMorePhotos: 'More Photos',
  stepperDepartureDate: 'Select your departure date',
  stepperDepartureDateMobile: 'Date',
  stepperPassengerInfo: 'Passenger Information',
  stepperPassengerInfoMobile: 'Info',
  destination: 'Destination',
  destinations: 'Destinations',
  easyQuote: 'Instant Quote',
  from: 'From',
  home: 'Home',
  hometownPrice: 'Price from my hometown',
  hometownPriceTruncated: 'View Price',
  passengerInfo: 'Passenger Details',
  selectDate: 'Select your date',
  stickyNavItinerary: 'Itinerary',
  stickyNavOnboard: 'Onboard',
  stickyNavOverview: 'Overview',
  stickyNavTrains: 'Trains',
  stickyNavTripDetails: 'Details',
  submitDetails: 'Continue to booking',
  tourDetailsHeader: 'Trip Details',
  tourDetailsTripHighlightsHeader: 'Trip Highlights',
  tourDetailsWhatsIncludedHeader: 'What\'s Included',
}

export const brandBreadCrumbLabel = {
  AMTRAK: 'Vacations',
  AVAU: 'Holidays',
  AVUK: 'Holidays',
  AVCA: 'Vacations',
  RAILBOOKER: 'Trips',
  RBCA: 'Trips',
  RBAU: 'Trips',
  RBUS: 'Trips',
}

export default labels
